import { styled } from '@mui/material/styles';
import { IconButton,  Typography } from '@mui/material';

export const VideoTriggerButton = styled(IconButton)({
  position: 'absolute',
  zIndex: 2,
  padding: '12px',
  color: '#ffffff',
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
  },
  '& .MuiSvgIcon-root': {
    fontSize: '48px',
  },
});

export const ErrorMessage = styled(Typography)(({ theme }) => ({
  color: '#d32f2f',
  marginTop: theme.spacing(1),
}));

export const VideoContainer = styled('div')({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '200px',
  minHeight: '200px',
  backgroundColor: '#f5f5f5',
  backgroundImage: 'linear-gradient(45deg, #f5f5f5 25%, #e0e0e0 25%, #e0e0e0 50%, #f5f5f5 50%, #f5f5f5 75%, #e0e0e0 75%, #e0e0e0)',
  backgroundSize: '20px 20px',
  borderRadius: '4px',
  overflow: 'hidden',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  '&:hover': {
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  },
});

export const PlaceholderImage = styled('img')({
  width: '100% !important',
  height: '100% !important',
  objectFit: 'contain',
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 1,
}); 